import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

function NavbarButton({ icon, onClick, isActive }) {
  return (
    <button
      className={cn(
        'text-left duration-150 ease-in-out transition-all bg-primitive-white hover:bg-light focus:ring-2 focus:ring-default focus:bg-light p-ds-8 rounded',
        {
          '!bg-dark': isActive,
        }
      )}
      type="button"
      onClick={onClick}
    >
      {typeof icon === 'function'
        ? icon({ className: 'h-ds-24 w-ds-24 text-muted' })
        : icon}
    </button>
  );
}

export default NavbarButton;

NavbarButton.defaultProps = {
  icon: false,
  isActive: false,
  onClick: () => {},
};

NavbarButton.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  onClick: PropTypes.instanceOf(Function),
  isActive: PropTypes.bool,
};
